import axios from 'axios';
import { ZUUL_API_BASE } from '../utils/constants';
import {
  createLogEntry,
  shouldAuditRequest,
  auditApi,
} from './auditLogger';

const api = axios.create({
  baseURL: ZUUL_API_BASE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Security-Policy': 'upgrade-insecure-requests',
    mode: 'cors',
  },
});

// Request interceptor to capture outgoing requests for audit logging
api.interceptors.request.use(
  (config) => {
    // Store request timestamp for audit logging
    if (shouldAuditRequest(config)) {
      config.metadata = { startTime: new Date() };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to capture responses and send audit logs
api.interceptors.response.use(
  async (response) => {
    // Log successful responses for non-GET requests
    if (shouldAuditRequest(response.config)) {
      const logEntry = createLogEntry(response.config, response);
      void sendAuditLog(logEntry);
    }
    return response;
  },
  async (error) => {
    // Log failed responses for non-GET requests
    if (error.config && shouldAuditRequest(error.config)) {
      const logEntry = createLogEntry(error.config, error.response, error);
      void sendAuditLog(logEntry);
    }
    return Promise.reject(error);
  }
);

/**
 * Send audit log to backend
 */
const sendAuditLog = async (logEntry) => {
  console.log("AUDIT LOG EVENT:", logEntry);
  try {
    void api.post('/events/log', logEntry);
  } catch (error) {
    // Don't throw errors for audit logging failures to avoid disrupting the main application
    console.error('Failed to send audit log:', error);
  }
};

export default api;
